import { Reveal } from "@/components/Reveal";
import MonoVideo from "@/components/MonoVideo";

export default function Showcase({ media, onApply }) {
  const slots = [
    { className: "md:col-span-5", delay: 0.05, height: "h-[360px] md:h-[560px]" },
    { className: "md:col-span-4 md:mt-16", delay: 0.12, height: "h-[360px] md:h-[520px]" },
    { className: "md:col-span-3 md:mt-32", delay: 0.18, height: "h-[360px] md:h-[420px]" },
    { className: "col-span-2 md:col-span-7", delay: 0.1, height: "h-[320px] md:h-[520px]" },
  ];

  // Asymmetric editorial grid layout
  return (
    <section
      id="showcase"
      data-testid="showcase-section"
      className="bg-[#ffffff] text-[#0a0a0a] py-24 md:py-32 px-6 md:px-10"
    >
      <div className="max-w-[1600px] mx-auto">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
            <div>
              <div className="flex items-center gap-4 mb-6">
                <span className="h-px w-12 bg-[#000000]" />
                <span className="text-xs uppercase tracking-[0.3em] font-bold text-[#737373]">
                  The Faces
                </span>
              </div>
              <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight leading-none">
                Faces we&rsquo;ve <span className="italic text-[#000000]">framed</span>.
              </h2>
              <p className="font-script text-[#000000] text-4xl md:text-6xl leading-none mt-4">
                picture yours right here.
              </p>
            </div>
            <p className="max-w-sm text-base text-[#0a0a0a]/60 leading-relaxed">
              A glimpse of the editorial energy we bring to every talent. Your feature could be next.
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-2 md:grid-cols-12 gap-4 md:gap-6">
          {slots.map((slot, i) => {
            const item = media[i];
            return (
              <Reveal key={i} className={slot.className} delay={slot.delay}>
                {item?.type === "video" ? (
                  <MonoVideo
                    src={item.src}
                    testId={`showcase-video-${i}`}
                    className={`w-full ${slot.height}`}
                    videoClassName="w-full h-full object-cover"
                    alt="Editorial reel"
                  />
                ) : (
                  <figure className="overflow-hidden">
                    <img
                      src={item?.src}
                      alt="Editorial model"
                      className={`editorial-img w-full ${slot.height} object-cover grayscale`}
                    />
                  </figure>
                )}
              </Reveal>
            );
          })}
          <Reveal className="col-span-2 md:col-span-5" delay={0.16}>
            <div className="h-full flex flex-col justify-between bg-[#0a0a0a] text-[#ffffff] p-8 md:p-12">
              <span className="font-display text-6xl md:text-8xl font-light text-[#ffffff] leading-none">200+</span>
              <div>
                <p className="text-base md:text-lg text-[#ffffff]/70 mb-8 leading-relaxed">
                  Campaigns booked for talent who started exactly where you are — with a dream and no roadmap.
                </p>
                <button
                  data-testid="showcase-apply-btn"
                  onClick={onApply}
                  className="inline-flex items-center rounded-full bg-[#000000] hover:bg-[#1f1f1f] text-white text-xs uppercase tracking-[0.2em] font-bold px-8 py-4 transition-colors duration-300"
                >
                  Add Your Face
                </button>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
